import React from "react";
import ModalForm from "./ModalForm";
import QRCode from "react-qr-code";
import FilterCard, {FIELD_TYPE} from "../FilterCard";
import ReactToPrint from "react-to-print";
import moment from "moment";
import Select from "react-select";
import {sweetalert} from "../../App";
import Validator, {ValidationEntry} from "../../validation/Validator";
import {Validators} from "../../validation/Validators";
import {BinAPI} from "../../network/BinAPI";
import AdminAPI from "../../network/AdminAPI";

interface CreateReceivingState{
    show_loading: boolean
    filter: object
    facilities: any
    submitted: boolean
    deliveredBy: string
    facilityName
    numOfSamples: string
    receivedBy: string
    currentDate: string
    binID: string
    DeliveredBy?
    FacilityID?
    NumberOfSamples?
    ReceivedBy?
}


export class CreateReceivingLabelModal extends React.Component<any, CreateReceivingState>{
    public formRef: React.RefObject<ModalForm>;
    private componentRef: any;
    constructor(props) {
        super(props);
        this.state = {
            show_loading: false,
            filter: {},
            facilities: [],
            submitted: false,
            deliveredBy: '',
            facilityName: '',
            numOfSamples: '',
            receivedBy: '',
            currentDate: moment().format('MM/DD/YYYY h:mm:ss a'),
            binID: '',
        };
        this.assignClearState = this.assignClearState.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

    }

    componentDidMount() {
        this.setState({show_loading: true}, () => {
            AdminAPI.getAllFacilities(true).then(data => {
                this.setState({
                    facilities: data.authorizedFacilities.map(fac => {
                        return {
                            label: fac.FacilityName,
                            value: fac.ID
                        }
                    }), show_loading: false
                })
            })
        })
    }

    clearFilterState:() => void = null;

    assignClearState(func){
        this.clearFilterState = func;
    }

    clearState = () =>{
        this.setState({facilityName: ''});
        this.clearFilterState();
    }

    onSubmit(e) {

        let formValidation = {
            Facility: this.state.facilityName,
            DeliveredBy: this.state.filter['DeliveredBy'],
            NumberOfSamples: this.state.filter['NumberOfSamples'],
            ReceivedBy: this.state.filter['ReceivedBy'],
        }

        let validator = new Validator<any>()
            .withSimpleValidation("Facility", Validators.requireNonNullValidator())
            .withValidation("DeliveredBy", Validators.requireNotBlankAndLength(200, "Delivered By"))
            .withComposedValidation("NumberOfSamples", new ValidationEntry(Validators.requireNotBlankValidator("Number of Samples")), new ValidationEntry(Validators.requireRange(1,100, "Number of Samples")), new ValidationEntry(Validators.requireIsInt("Number of Samples")))
            .withValidation("ReceivedBy", Validators.requireNotBlankAndLength(200, "Received By"))
        let validationResponse = validator.validate(formValidation);
        if(!validationResponse.success) {
            return sweetalert.fire({icon: 'error', title: '', text: validationResponse.error});
        }

        this.setState({show_loading: true})

        this.insertSampleReceiving(this.state.filter['DeliveredBy'], this.state.facilityName.value, this.state.filter['NumberOfSamples'], this.state.filter['ReceivedBy'])

}

async insertSampleReceiving(droppedBy, facilityID, numSamples, receivedBy){

    let tempBinID = ''
    try {
        let result = await BinAPI.insertBinRec({droppedBy: droppedBy, facilityID: facilityID, numSamples: numSamples, receivedBy: receivedBy})
        if(result.success){
            tempBinID = 'BC' + result.response[0]
            this.setState({binID: tempBinID, submitted: true, show_loading: false})
        }
    }
    catch (e) {
        console.error(e)
    }

}

    public static display(){
        window["$"]("#" + CreateReceivingLabelModal.ID).modal('show');

    }

    public static readonly ID = "createLabel"
    render(): React.ReactElement | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return (
            <React.Fragment>

                <div className="modal fade form_modal" id={CreateReceivingLabelModal.ID} tabIndex={-1} role="dialog"
                     aria-labelledby="result_modal_label"
                     aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-body p-0 m-0">
                                <div className="container-fluid">
                                    <div className={"row"}>
                                        <div className="col-xl-12 col-lg-12 col-md-12 col-12 pt-2">
                                            <div className="card mb-2">
                                                <div className="modal-header" style={{borderBottom: '1px solid grey'}}>
                                                    <h3 className="modal-title">Create Receiving Label</h3>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                {/*<div className="card-header verlag-bold">*/}
                                                {/*    <h3>Receiving Label</h3>*/}
                                                {/*    <button type="button" className="close" data-dismiss="modal" aria-label="Close">*/}
                                                {/*        <span aria-hidden="true">&times;</span>*/}
                                                {/*    </button>*/}
                                                {/*</div>*/}
                                                <div className="card-body">
                                        <div className="form-group row">
                                            <div className={"col-4"}>
                                                <label className="col-form-label" htmlFor={'Facility'}>Facility</label>
                                            </div>

                                            <div className={"col-8 pl-0 pr-1"}>
                                                <Select
                                                    id={'Facility'}
                                                    isSearchable={true}
                                                    placeholder={"Please Select..."}
                                                    onChange={(e)=> this.setState({facilityName: e})}
                                                    className={"state_select"}
                                                    options={this.state.facilities}
                                                    value={this.state.facilityName}
                                                    isDisabled={this.state.submitted}
                                                />
                                            </div>
                                        </div>

                                        <FilterCard
                                            passClearStateFunc={this.assignClearState}
                                            fields={[
                                                {
                                                    label: "Delivered By",
                                                    "key": "DeliveredBy",
                                                    type: FIELD_TYPE.TEXT,
                                                    placeholder: "Enter drop-off person name",
                                                    disable: this.state.submitted,
                                                    maxLength: 200
                                                },
                                                {
                                                    label: "# of Samples",
                                                    "key": "NumberOfSamples",
                                                    type: FIELD_TYPE.NUMBER,

                                                    min: 1,
                                                    max: 1000,
                                                    placeholder: "Enter number of samples",
                                                    disable: this.state.submitted
                                                },
                                                {
                                                    label: "Received By",
                                                    "key": "ReceivedBy",
                                                    type: FIELD_TYPE.TEXT,
                                                    placeholder: "Enter receiver's name",
                                                    disable: this.state.submitted,
                                                    maxLength: 200
                                                },
                                            ]} filterChanged={(filter) => this.setState({filter: filter})}/>
                                    </div>
                                    <div className="card-footer">
                                        {this.state.submitted ?
                                        <>
                                            <button className="btn btn-outline-primary d-none" onClick={(e) => this.onSubmit(e)}>Submit
                                            </button>

                                            <ReactToPrint
                                            trigger={() => <button className={"btn btn-outline-success"} style={{float: 'right'}}>Print Label</button>}
                                            // @ts-ignore
                                            content={() => this.componentRef}
                                            onAfterPrint={() => {this.setState({submitted: false}); this.clearState()}}
                                            />
                                        </>:
                                        <>
                                            <button className="btn btn-outline-primary" onClick={(e) => this.onSubmit(e)}>Submit
                                            </button>

                                            <ReactToPrint
                                            trigger={() => <button className={"btn btn-outline-success"} style={{float: 'right', display: 'none'}}>Print Label</button>}
                                            // @ts-ignore
                                            content={() => this.componentRef}
                                            />
                                        </>
                                        }
                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                           

                {this.state.submitted ?
                    <div className={"m-5 "}>
                        <div className={"container"} >
                            <div className="row" style={{marginTop: '1em'}}>
                                <div className="col-2"></div>
                                <div className="col-8">
                                    <table className="table table-borderless" style={{borderBottom: '5px solid black'}}>
                                        <tbody className={"text-center"}>
                                                <tr>
                                                    <td style={{width: '50%', fontWeight: 'bold', fontSize: '1.5em'}}>Dropped By:</td>
                                                    <td style={{width: '50%', fontWeight: 'bold',fontSize: '1.5em'}}>{this.state.filter['DeliveredBy']}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{width: '50%', fontWeight: 'bold', fontSize: '1.5em'}}>Facility:</td>
                                                    <td style={{width: '50%', fontWeight: 'bold',fontSize: '1.5em'}}>{this.state.facilityName ? this.state.facilityName.label: ''}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{width: '50%', fontWeight: 'bold', fontSize: '1.5em'}}># Samples:</td>
                                                    <td style={{width: '50%', fontWeight: 'bold',fontSize: '1.5em'}}>{this.state.filter['NumberOfSamples']}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{width: '50%', fontWeight: 'bold', fontSize: '1.5em'}}>Date Dropped:</td>
                                                    <td style={{width: '50%', fontWeight: 'bold',fontSize: '1.5em'}}>{this.state.currentDate}</td>
                                                </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-2"></div>
                            </div>
                            <div className="row" ></div>
                            <div className="row mt-4">
                                <div className="col-2"></div>
                                <div className="col-8 text-center">
                                    <div className={"mb-3"}>
                                        <QRCode value={ this.state.binID ? this.state.binID : ''} size={150} />
                                    </div>
                                    <div className={"mb-3"} style={{fontWeight: 'bold', fontSize: '2.5em'}}>{this.state.binID ? this.state.binID : ''}</div>
                                </div>
                                <div className="col-2"></div>

                            </div>
                        </div>



                    <div className={"m-5 d-none"}>
                        <div className={"container"} ref={el => (this.componentRef = el)}>
                            <div className="row" style={{marginTop: '1em'}}>
                                {/*<div className="col-2"></div>*/}
                                <div className="col-10">
                                    <table className="table table-borderless" style={{borderBottom: '5px solid black'}}>
                                        <tbody className={"text-center"}>
                                        <tr>
                                            <td style={{width: '50%', fontWeight: 'bold', fontSize: '1.5em'}}>Dropped By:</td>
                                            <td style={{width: '50%', fontWeight: 'bold',fontSize: '1.5em'}}>{this.state.filter['DeliveredBy']}</td>
                                        </tr>
                                        <tr>
                                            <td style={{width: '50%', fontWeight: 'bold', fontSize: '1.5em'}}>Facility:</td>
                                            <td style={{width: '50%', fontWeight: 'bold',fontSize: '1.5em'}}>{this.state.facilityName ? this.state.facilityName.label : ''}</td>
                                        </tr>
                                        <tr>
                                            <td style={{width: '50%', fontWeight: 'bold', fontSize: '1.5em'}}># Samples:</td>
                                            <td style={{width: '50%', fontWeight: 'bold',fontSize: '1.5em'}}>{this.state.filter['NumberOfSamples']}</td>
                                        </tr>
                                        <tr>
                                            <td style={{width: '50%', fontWeight: 'bold', fontSize: '1.5em'}}>Date Dropped:</td>
                                            <td style={{width: '50%', fontWeight: 'bold',fontSize: '1.5em'}}>{this.state.currentDate}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-2"></div>
                            </div>
                            <div className="row" ></div>
                            <div className="row mt-4">
                                {/*<div className="col-2"></div>*/}
                                <div className="col-10 text-center">
                                    <div className={"mb-3"}>
                                        <QRCode value={ this.state.binID ? this.state.binID : ''} size={150} />
                                    </div>
                                    <div className={"mb-3"} style={{fontWeight: 'bold', fontSize: '2.5em'}}>{this.state.binID ? this.state.binID : ''}</div>
                                </div>
                                <div className="col-2"></div>

                            </div>
                        </div>
                    </div>
                </div>: <div style={{display: 'none'}}></div>}
                </div>
                        </div>
                    </div>
                        </div>


            </React.Fragment>
        )
    }
}

